import * as R from 'ramda';
import { mapProps } from 'recompose';
import Media from 'components/general/Media/Media';
import getStaticMapImg from 'utils/getStaticMapImg';

const applySpec = item => R.applySpec({
  title: R.prop('title'),
  summary: R.prop('detail'),
  date: R.prop('when'),
  category: R.ifElse(
    R.has('category'),
    R.prop('category'),
    R.prop('geography'),
  ),
  small: R.prop('small'),
  event: R.prop('event'),
  tags: R.pipe(
    R.pick(['riskType', 'contentTags']),
    R.toPairs,
    R.map(
      R.cond([
        [
          R.propEq(0, 'riskType'),
          R.pipe(
            R.last,
            ({ slug, title }) => ([{
              label: title,
              type: 'primary',
              to: {
                type: 'ALERTS_INDEX',
                query: {
                  riskTypes: [slug],
                  contentTags: [],
                },
              },
            }]),
          ),
        ],
        [
          R.propEq(0, 'contentTags'),
          R.pipe(
            R.last,
            R.reject(R.isEmpty),
            R.map(({ slug, title }) => ({
              label: title,
              type: 'secondary',
              to: {
                type: 'ALERTS_INDEX',
                query: {
                  riskTypes: [],
                  contentTags: [slug],
                },
              },
            })),
          ),
        ],
      ]),
    ),
    R.reject(R.isNil),
    R.flatten,
  ),
  image: {
    src: R.pipe(
      R.prop('point'),
      getStaticMapImg,
    ),
  },
  href: {
    type: R.always('ALERTS_SINGLE'),
    payload: {
      slug: R.prop('slug'),
    },
  },
  actions: R.pipe(
    R.ifElse(
      R.has('actions'),
      R.prop('actions'),
      R.always(
        [{
          icon: 'map-marker',
          title: 'View on map',
          to: {
            type: 'MAP',
            query: {
              marker: R.prop('id', item),
            },
          },
        }],
      ),
    ),
  ),
})(item);

/**
 * A `Media` component with props pre-mapped for alerts. Just for convenience
 * when re-using `Media` with alerts across views.
 */
const AlertSummary = mapProps(props => (
  R.pipe(
    applySpec,
    R.omit(props.hide || []),
  )(props)
))(Media);

export default AlertSummary;
